import AiAgentBrainsAPI from 'dashboard/api/aiAgents/brains';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

// D36: Vuex module mirroring store/captain/* shapes. Errors on update/publish/
// hire are re-thrown untouched so pages can branch on HTTP status (409 stale
// draft, 422 invalid draft) instead of a swallowed toast.
export default createStore({
  name: 'AiAgentBrain',
  API: AiAgentBrainsAPI,
  mutations: {
    UPDATE_AI_AGENT_BRAIN_ATTRIBUTES: MutationHelpers.updateAttributes,
  },
  actions: mutations => ({
    // index has no meta block — the factory default get would crash on it.
    get: async ({ commit }) => {
      commit(mutations.SET_UI_FLAG, { fetchingList: true });
      try {
        const response = await AiAgentBrainsAPI.get();
        commit(mutations.SET, response.data.payload);
        return response.data.payload;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { fetchingList: false });
      }
    },
    update: async ({ commit }, { id, draftConfig, lockVersion }) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await AiAgentBrainsAPI.update(id, {
          draftConfig,
          lockVersion,
        });
        commit(mutations.EDIT, response.data);
        return response.data;
      } finally {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
      }
    },
    publish: async ({ commit, dispatch }, { id, changeNotes }) => {
      commit(mutations.SET_UI_FLAG, { publishingItem: true });
      try {
        const response = await AiAgentBrainsAPI.publish(id, changeNotes);
        // re-fetch the brain so latest_version_number / lock_version refresh
        await dispatch('show', id);
        return response.data;
      } finally {
        commit(mutations.SET_UI_FLAG, { publishingItem: false });
      }
    },
    killSwitch: async ({ commit }, id) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        await AiAgentBrainsAPI.killSwitch(id);
        commit('UPDATE_AI_AGENT_BRAIN_ATTRIBUTES', {
          id,
          kill_switched: true,
        });
        return true;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
      }
    },
    activity: async ({ commit }, id) => {
      commit(mutations.SET_UI_FLAG, { fetchingActivity: true });
      try {
        const response = await AiAgentBrainsAPI.activity(id);
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { fetchingActivity: false });
      }
    },
    hire: async ({ commit }, { source, handle, name }) => {
      commit(mutations.SET_UI_FLAG, { creatingItem: true });
      try {
        const response = await AiAgentBrainsAPI.hire({ source, handle, name });
        commit(mutations.UPSERT, response.data);
        return response.data;
      } finally {
        commit(mutations.SET_UI_FLAG, { creatingItem: false });
      }
    },
  }),
});
